let desktopVersion = window.innerWidth > 1024;

function syncSubmenuPanels(menuItemSub, isMobile) {
  const navPdm = menuItemSub.closest(".navigation-pdm");
  if (!navPdm) return;

  const menuHandle = menuItemSub.dataset.handle;
  const multiMenus = navPdm.querySelectorAll(".menu-item-sub");
  const secondMenus = navPdm.querySelectorAll(
    ".submenu-wrapper:not(.submenu-wrapper--mega-style2)"
  );

  if (isMobile) {
    if (menuItemSub.classList.contains("active")) {
      multiMenus.forEach((m) => m.classList.remove("active"));
    } else {
      multiMenus.forEach((m) => m.classList.remove("active"));
      menuItemSub.classList.add("active");
    }
  } else {
    multiMenus.forEach((m) => m.classList.remove("active"));
    menuItemSub.classList.add("active");
    secondMenus.forEach((sub) => {
      sub.classList.toggle("active", sub.id === menuHandle);
    });
  }
}

function activateFirstSubmenuDesktop(navPdm) {
  const first = navPdm.querySelector(".nav-dropdown-left .menu-item-sub");
  if (first) {
    syncSubmenuPanels(first, false);
  }
}

function clickLevelOneMenu(targetMain) {
  if (!targetMain) return;
  targetMain.forEach((navigation) => {
    navigation.addEventListener("click", (e) => {
      e.preventDefault();
      const parent = navigation.parentElement;
      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
      } else {
        if (desktopVersion) {
          targetMain.forEach((nav) => {
            nav.parentElement.classList.remove("active");
          });
          parent.classList.add("active");
          activateFirstSubmenuDesktop(parent);
        } else {
          parent.classList.add("active");
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const navigationPDM = document.querySelectorAll(".main-navigation-pdm");
  if (!navigationPDM.length) return;

  const navigationMain = document.querySelectorAll(
    ".main-navigation-pdm .navigation-pdm:not(.navigation-pdm--link-only) .nav-link"
  );
  const multiMenus = document.querySelectorAll(".main-navigation-pdm .menu-item-sub");

  if (desktopVersion) {
    document.addEventListener("click", (e) => {
      const clickTarget = e.target;
      if (!navigationPDM[0].contains(clickTarget)) {
        document.querySelectorAll("#main_nav .navigation-pdm").forEach((nav) => {
          nav.classList.remove("active");
        });
      }
    });
  }

  clickLevelOneMenu(navigationMain);

  const menusMobile = document.querySelectorAll("#mob_nav .navigation-pdm");
  const hamburMenu = document.querySelector(".hdicon.js-mobile-nav-toggle");
  const subwrapperMenu = document.querySelectorAll(
    ".main-navigation-pdm .submenu-wrapper:not(.submenu-wrapper--mega-style2)"
  );

  if (hamburMenu) {
    hamburMenu.addEventListener("click", () => {
      menusMobile.forEach((menu) => {
        menu.classList.remove("active");
      });
      multiMenus.forEach((menu) => {
        menu.classList.remove("active");
      });
      subwrapperMenu.forEach((menu) => {
        menu.classList.remove("active");
      });
      if (menusMobile[0]) {
        menusMobile[0].classList.add("active");
      }
    });
  }

  multiMenus.forEach((menu) => {
    menu.addEventListener("click", (e) => {
      e.stopPropagation();
      syncSubmenuPanels(menu, !desktopVersion);
    });
  });
});
